// @ts-nocheck
import {faHome, faPaw, faTicketAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useLocation, useNavigate} from "react-router-dom";

const navbarCls =
  "fixed bottom-0 left-0 right-0 h-20 bg-[var(--color-secondary)] border-t border-[var(--color-border)] shadow-[0_-2px_10px_rgba(0,0,0,0.1)] z-[1001] max-md:h-[var(--size-17-5)] max-[480px]:h-[65px] landscape:max-h-[var(--size-125)]:h-[55px]";
const navContentCls = "flex h-full max-w-full mx-auto items-center justify-around px-4 max-[480px]:px-2";
const navItemBaseCls =
  "flex flex-col items-center justify-center flex-1 min-h-[var(--size-15)] bg-none border-0 cursor-pointer transition-all duration-300 text-[var(--color-neutral-600)] font-inherit py-2 px-1 rounded-lg hover:bg-[var(--color-surface-light)] hover:text-[var(--color-info)] max-md:min-h-[var(--size-12-5)] max-md:py-1.5 max-md:px-0.5 max-[480px]:min-h-[var(--size-11-25)] max-[480px]:py-1 max-[480px]:px-[1px] landscape:max-h-[var(--size-125)]:min-h-[var(--space-7)]";
const navItemActiveCls = "text-[var(--color-info)] bg-[var(--color-info-bg)]";
const navIconCls =
  "text-xl mb-1 transition-transform duration-300 max-md:text-[var(--font-h2)] max-md:mb-[3px] max-[480px]:text-base max-[480px]:mb-0.5 landscape:max-h-[var(--size-125)]:text-sm";
const navIconActiveCls = "scale-110";
const navLabelCls =
  "text-xs font-medium text-center leading-[1.2] whitespace-nowrap max-md:text-[var(--font-caption)] max-[480px]:text-[var(--font-eyebrow)] landscape:max-h-[var(--size-125)]:text-[var(--font-eyebrow)]";

const LovenNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      key: "inicio",
      label: "Inicio",
      icon: faHome,
      path: "/lotoven/home",
    },
    {
      key: "animalitos",
      label: "Animalitos",
      icon: faPaw,
      path: "/lotoven/animalitos",
    },
    {
      key: "loterias",
      label: "Loterias",
      icon: faTicketAlt,
      path: "/lotoven/loterias",
    },
  ];

  const handleNavigation = path => {
    navigate(path);
  };

  const isActive = path => {
    if (path === "/lotoven/home") {
      return location.pathname === "/lotoven" || location.pathname === "/lotoven/home";
    }
    return location.pathname === path;
  };

  return (
    <div className={navbarCls}>
      <div className={navContentCls}>
        {navItems.map(item => (
          <button
            key={item.key}
            className={`${navItemBaseCls} ${isActive(item.path) ? navItemActiveCls : ""}`}
            onClick={() => handleNavigation(item.path)}
            type="button"
          >
            <FontAwesomeIcon
              icon={item.icon}
              className={`${navIconCls} ${isActive(item.path) ? navIconActiveCls : "hover:scale-110"}`}
            />
            <span className={navLabelCls}>{item.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default LovenNavbar;
